// The member literals of the ecosystem vocabularies as plain data. The Effect schemas, the frozen
// Zod enums and the dependency-free policy record all read them from here, so a browser bundle
// that only needs the record never loads Effect Schema.

/** The regulatory ecosystems, shared by the Effect `Ecosystem` and its frozen Zod enum. */
export const ECOSYSTEMS = ['ofb', 'opin'] as const;

/** Which authority publishes this ecosystem's regulation and its Directory. */
export const ECOSYSTEM_REGULATORS = ['bcb', 'susep'] as const;

/** The Keycloak realm name that carries an ecosystem's authorisation server. */
export const AUTHORISATION_SERVER_REALMS = ['finnest-ofb', 'finnest-opin'] as const;

/** Which bounded context's Postgres schema holds this ecosystem's participant directory. */
export const DIRECTORY_BOUNDED_CONTEXTS = ['banking', 'insurance'] as const;

/**
 * Which organisation identifier a Directory-issued software statement carries.
 *
 * OFB Directory SSAs guarantee `org_cnpj` (OFB DCR ID3); a real OPIN SSA (Perfil unico, Confluence
 * page 45351471 v10) carries `org_number` and no `org_cnpj`.
 */
export const SOFTWARE_STATEMENT_ORG_IDENTIFIERS = ['org-cnpj', 'org-number'] as const;

/**
 * Whether a Directory-issued software statement carries its own `exp`.
 *
 * OFB SSAs do. OPIN SSAs do not — freshness there is the five-minute `iat` rule alone, so requiring
 * `exp` on the OPIN path would reject every real statement.
 */
export const SOFTWARE_STATEMENT_EXPIRIES = ['required', 'absent'] as const;

/**
 * How the regulatory catalogue groups the generated family rows into families.
 *
 * OFB keeps one family per generated row. OPIN collapses rows that resolve to the same insurance
 * type, because the SUSEP catalogue splits one licensable product across several rows.
 */
export const CATALOGUE_FAMILY_GROUPINGS = ['per-family-row', 'merge-by-insurance-type'] as const;

/**
 * Where a catalogue family's phase label comes from.
 *
 * OFB rows state a BCB phase that is normalised (`2.x` collapses to `phase-2`); OPIN rows state a
 * track that is taken as written.
 */
export const CATALOGUE_PHASE_LABEL_SOURCES = ['normalised-ofb-phase', 'raw-track'] as const;

/**
 * Which claim decides whether a customer may run a catalogue family.
 *
 * OFB authorises on the Directory roles in the SSA (`DADOS` / `PAGTO`); OPIN authorises on the
 * insurance types the licensed scope names.
 */
export const CATALOGUE_SCOPE_AUTHORITIES = ['directory-roles', 'insurance-types'] as const;
